<div class="mb-2">
  <progressbar class="progress-striped active"  [value]="136" type="danger"><i>136 / 150</i></progressbar>
</div>
